/** Match a bag service to the shop's bag-size guide (label / size words). */

const SIZE_STEPS = [
  [/extra[\s-]*large|x[\s-]*large|\bxlarge\b|\bxxl\b|\bxl\b/gi, ' xl '],
  [/\bsmall\b|\bsm\b/gi, ' small '],
  [/\bmedium\b|\bmed\b/gi, ' medium '],
  [/\blarge\b|\blg\b/gi, ' large '],
];

export function sizeTokens(text) {
  let t = ` ${text || ''} `;
  SIZE_STEPS.forEach(([pat, repl]) => {
    t = t.replace(pat, repl);
  });
  return new Set((t.toLowerCase().match(/small|medium|large|xl|\d+/g) || []));
}

export function weightCap(row) {
  if (!row) return 0;
  const raw = row.weightCap ?? row.weight_cap;
  const n = parseFloat(String(raw ?? '').replace(/[^0-9.]+/g, ''));
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function matchGuideRow(serviceName, guide) {
  const name = (serviceName || '').trim();
  const nameL = name.toLowerCase();
  const nameTokens = sizeTokens(name);
  let best = null;
  let bestScore = 0;
  (guide || []).forEach((row) => {
    const label = (row?.label || '').trim();
    if (!label) return;
    const labelL = label.toLowerCase();
    let score = 0;
    if (nameL && (nameL.includes(labelL) || labelL.includes(nameL))) score += 3;
    const overlap = [...nameTokens].filter((tok) => sizeTokens(`${label} ${row.capacity || ''}`).has(tok));
    score += overlap.length;
    if (score > bestScore) {
      best = row;
      bestScore = score;
    }
  });
  return bestScore > 0 ? best : null;
}

export function formatOverageRate(rate) {
  const n = parseFloat(rate);
  if (!Number.isFinite(n) || n <= 0) return '';
  return `$${n.toFixed(2)}/lb`;
}
